import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from 'atoms/Modal';

import StyledPauseMatchModal from './StyledPauseMatchModal';
import Button, { SecondaryButton } from 'styled/components/Button';

import { ModalProps } from 'atoms/Modal/ModalTypes';

import { modalsSlice } from 'features/modals/modalsSlice';
import { startSecondHalfExtraTime } from 'features/match/thunks';
import { useAppDispatch } from '../../../hooks/hooks';

const StartSecondHalfExtraTimeModal: React.FC<ModalProps> = (props) => {
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(modalsSlice.actions.setSecondHalfExtraTimeModal(false));
  };

  return (
    <Modal {...props}>
      <StyledPauseMatchModal>
        <div />
        <div className="text">
          <FormattedMessage id="modals.startSecondHalfExtraTime" />
        </div>
        <div className="actions">
          <Button
            onClick={() => {
              dispatch(startSecondHalfExtraTime({}));
              close();
            }}
          >
            <FormattedMessage id="buttons.startSecondHalfExtraTime" />
          </Button>
          <SecondaryButton whiteBackground greenText onClick={close}>
            <FormattedMessage id="buttons.cancel" />
          </SecondaryButton>
        </div>
      </StyledPauseMatchModal>
    </Modal>
  );
};

export default StartSecondHalfExtraTimeModal;
